import { Photo } from 'meta/photo/photo'
import { Project } from 'meta/project/project'
import { Story } from 'meta/story/story'

const joinParts = (...strings: Array<string>): string => `/api/${strings.join('/')}`

export const ApiEndpoints = {
  health: (): string => joinParts('health'),

  Projects: {
    photoPoints: (projectName: Project['name'] = ':projectName'): string =>
      joinParts('projects', projectName, 'photos', 'points'),
  },

  Stories: {
    one: (projectName: Project['name'] = ':projectName', storyName: Story['name'] = ':storyName'): string =>
      joinParts('projects', projectName, 'stories', storyName),
  },

  Photos: {
    photoData: (photoUuid: Photo['uuid'] = ':photoUuid'): string => joinParts('photos', photoUuid, 'data'),
  },
}
